import { h } from '@/lib/dom';
import { InfoTip } from '@/components/InfoTip';

export function DeepDiveTile(
  label: string,
  value: string,
  unit: string,
  tooltip?: string,
): HTMLElement {
  return h('div', { class: 'deepdive-tile' }, [
    h('span', { class: 'deepdive-label' }, [
      h('span', { class: 'deepdive-label-text' }, label),
      tooltip ? InfoTip(tooltip, label) : null,
    ]),
    h('span', { class: 'deepdive-value-row' }, [
      h('span', { class: 'deepdive-value' }, value),
      unit ? h('span', { class: 'deepdive-unit' }, unit) : null,
    ]),
  ]);
}
